import { Component, Input, OnInit } from '@angular/core';
import { UxService } from 'src/app/core/services/ux.service';
import { ReleaseListBaseComponent } from 'src/app/open-age/gateway/components/release-list.base.component';
import { Project } from 'src/app/open-age/gateway/models/project.model';
import { ReleaseService } from 'src/app/open-age/gateway/services/release.service';

@Component({
  selector: 'gateway-release-list',
  templateUrl: './release-list.component.html',
  styleUrls: ['./release-list.component.css']
})
export class ReleaseListComponent extends ReleaseListBaseComponent {
  constructor(
    releaseService: ReleaseService,
    uxService: UxService
  ) {
    super(releaseService, uxService);
  }
}
